import React from 'react';
import { mediaUrl } from '../../api/client';

// Renders the product "page builder" blocks below the buy box (image / image+text / text / video / html / gallery)
export default function ContentBlocks({ blocks = [] }) {
  if (!blocks.length) return null;
  return (
    <div className="apb_layout eg-content-blocks">
      {blocks.map((b, i) => {
        if (b.type === 'image' && b.image) {
          return (
            <div className="apb_reset" key={b._id || i}>
              <div className="apb_image_section" style={b.background ? { background: b.background } : undefined}>
                <div className="apb_image_row"><div className="apb_image_column"><span className="apb_image_img_btn apb_aline_space"><img className="apb_image_img" src={mediaUrl(b.image)} alt={b.heading || ''} loading="lazy" /></span></div></div>
              </div>
            </div>
          );
        }
        if (b.type === 'gallery' && b.images?.length) {
          return (
            <div className="apb_reset" key={b._id || i}>
              <div className="apb_common_padding">
                {b.heading && <h2 className="text-2xl md:text-3xl font-medium text-center mb-6">{b.heading}</h2>}
                <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                  {b.images.map((img, j) => <img key={j} src={mediaUrl(img)} alt={`${b.heading || ''} ${j + 1}`} className="w-full rounded" loading="lazy" />)}
                </div>
              </div>
            </div>
          );
        }
        if (b.type === 'image_text') {
          return (
            <div className="apb_reset" key={b._id || i}>
              <div className="apb_image_with_text_section apb_common_padding" style={b.background ? { background: b.background } : undefined}>
                <div className={`apb_image_with_text_row ${b.reverse ? 'apb_image_with_text_row_reserve' : ''}`}>
                  <div className="apb_image_with_text_column">
                    {b.image && <span className="apb_image_with_text_img_btn apb_aline_space"><img className="apb_image_with_text_img" src={mediaUrl(b.image)} alt={b.heading || ''} loading="lazy" /></span>}
                  </div>
                  <div className="apb_image_with_text_column">
                    {b.heading && <div className="apb_image_with_text_heading" style={{ color: '#333333', width: '100%', textAlign: 'left' }}>{b.heading}</div>}
                    <div className="apb_image_with_text_text" dangerouslySetInnerHTML={{ __html: b.text || '' }} />
                  </div>
                </div>
              </div>
            </div>
          );
        }
        if (b.type === 'text') {
          return (
            <div className="apb_reset" key={b._id || i}>
              <div className="apb_text_section apb_common_padding">
                <div className="apb_text_row"><div className="apb_text_column">
                  {b.heading && <h2 className="text-2xl md:text-3xl font-medium mb-4">{b.heading}</h2>}
                  <div className="rte" dangerouslySetInnerHTML={{ __html: b.text || '' }} />
                </div></div>
              </div>
            </div>
          );
        }
        if (b.type === 'video' && b.videoUrl) {
          const yt = b.videoUrl.match(/(?:youtu\.be\/|v=)([\w-]+)/);
          return (
            <div className="apb_reset" key={b._id || i}>
              <div className="apb_common_padding" style={{ maxWidth: 960 }}>
                {b.heading && <h2 className="text-2xl md:text-3xl font-medium text-center mb-6">{b.heading}</h2>}
                <div className="eg-video-wrap">
                  {yt ? <iframe src={`https://www.youtube.com/embed/${yt[1]}`} title={b.heading || 'Video'} allowFullScreen loading="lazy" /> : <video src={mediaUrl(b.videoUrl)} controls poster={mediaUrl(b.image)} />}
                </div>
              </div>
            </div>
          );
        }
        if (b.type === 'html' && b.text) {
          return <div className="apb_reset" key={b._id || i}><div className="apb_common_padding" dangerouslySetInnerHTML={{ __html: b.text }} /></div>;
        }
        return null;
      })}
    </div>
  );
}
